// extracted by mini-css-extract-plugin
module.exports = {"Box":"Box_Box__2YCDc","Group":"Box_Group__xp5IP"};